module.exports = __webpack_public_path__ + "07_medium_brown.a5e3f2f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/07_medium_brown.png
// module id = D5Fg
// module chunks = 0